import { render, staticRenderFns } from "./BlogSectionCategoriesCarousel.vue?vue&type=template&id=16d44032&scoped=true&lang=pug&"
import script from "./BlogSectionCategoriesCarousel.vue?vue&type=script&lang=js&"
export * from "./BlogSectionCategoriesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BlogSectionCategoriesCarousel.vue?vue&type=style&index=0&id=16d44032&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d44032",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16d44032')) {
      api.createRecord('16d44032', component.options)
    } else {
      api.reload('16d44032', component.options)
    }
    module.hot.accept("./BlogSectionCategoriesCarousel.vue?vue&type=template&id=16d44032&scoped=true&lang=pug&", function () {
      api.rerender('16d44032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/BlogSectionCategoriesCarousel.vue"
export default component.exports